import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import InPlayPopularHeader from '../InPlayPopularHeader/inplay-poplular-header'
import GetListsItems from './getListItems/GetListsItems'


const InPlayPopular = ({
  inPlayEvents,
  balanceSettings,
  timeSettings,
  type,
  displayedBack,
  setDisplayedBack,
  betPlacing,
  orderCount,
  promotions,
  navigationID = '',
}) => {
  const [inPlayEventsMap, setInPlayEventsMap] = useState(new Map())
  const user = useSelector((state) => state.user);


  const updateInPlayEventsMap = useCallback(() => {
    if (!inPlayEvents) return;

    const newMap = new Map();
    inPlayEvents.forEach((e) => {
      // if(user?.verifytoken && !user?.details?.availableEventTypes.includes(e.actualEventTypeId || e.eventTypeId)) {
      //   return;
      // }

      const evId = Number(e.sport_id)
      if (newMap.has(evId)) {
        newMap.get(evId).push(e);
      } else {
        newMap.set(evId, [e]);
      }
    })
    if (promotions && promotions?.popularBanners) {
      promotions.popularBanners.forEach((e) => {
        const evId = 1111111;
        if (newMap.has(evId)) {
          newMap.get(evId).push(e);
        } else {
          newMap.set(evId, [e]);
        }
      })
    }

    setInPlayEventsMap(newMap)
  }, [inPlayEvents, promotions, user])

  useEffect(() => {
    updateInPlayEventsMap()
  }, [updateInPlayEventsMap]);
  
 
  return (
    <div className={"py-1 px-[6px] w-full"}>
      <div className=" w-full font-helvetica-neue">
        <InPlayPopularHeader type={type} orderCount={orderCount} />

        <GetListsItems 
          inPlayEventsMap={inPlayEventsMap}
          type={type}
          timeSettings={timeSettings}
          betPlacing={betPlacing}
          displayedBack={displayedBack}
          setDisplayedBack={setDisplayedBack}
          balanceSettings={balanceSettings}
          navigationID={navigationID}
        />
      </div>
    </div>
  )
}

export default InPlayPopular
